exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-head__img[data-v-18252c38] {\n  max-width: 100%;\n}", ""]);

// exports
